import axios from "axios";

const api = async (method, url, payload) => {
  try {
    let response;
    let APP_URL = process.env.VUE_APP_URL;
    let CONFIG = {
      headers: {
        Accept: "application/json",
        Authorization:
          "Bearer UpmoodAPI-a0XbCZeTxi1zW9sU5Y2GoQf1M0G55m3JNPrHNH96JSJNpj2SOwaMUggW5V9U"
      }
    };

    if (method === "get") {
      response = await axios.get(APP_URL + url, CONFIG);
    } else if (method === "post") {
      response = await axios.post(APP_URL + url, payload, CONFIG);
    }

    const { data } = response;

    if (data) {
      const result = {
        status: true,
        data: data
      };

      return result;
    }

    return false;
  } catch ({ response }) {
    try {
      const { data } = response;

      if (data) {
        const result = {
          status: false,
          data: data
        };

        return result;
      }
    } catch (e) {
      return e;
    }
  }
};

export default api;
